export default __webpack_public_path__ + "static/media/chemist.a8b5f4df.jpg";